import { CompleteYourLookLook } from "../../../domain/projections/CompleteYourLookLook";
import { Container } from "../../ui/shared/types";

interface CompleteYourLookLookDTO {
  readonly layout: string;
  readonly lookId: string;
  readonly items: {
    readonly imageUrl: string;
    readonly purchased: boolean;
    readonly variantId: string;
    readonly container: string;
  }[];
}

const mapCompleteYouLookLookDTOtoCompleteYourLookLook = (lookDTO: CompleteYourLookLookDTO): CompleteYourLookLook => {
  return {
    layout: lookDTO.layout,
    lookId: lookDTO.lookId,
    items: lookDTO.items.map((item) => ({
      imageUrl: item.imageUrl,
      purchased: item.purchased,
      variantId: item.variantId,
      container: item.container as Container,
    })),
  };
};

export type { CompleteYourLookLookDTO };
export { mapCompleteYouLookLookDTOtoCompleteYourLookLook };
